import $ from 'jquery';


/* Article tables
********************************************/

if ($('.text-editor').length) {
	$('.text-editor table').wrap('<div class="table-responsive-md"></div>');
}


/* Adding class on anchor that contains image
********************************************/

if ($('.text-editor').length) {
	$('.text-editor p a:has(img), .text-editor .wp-caption a:has(img)').addClass('article-image-link');
	$('.text-editor img').closest('p').addClass('article-image-container');
}

/* Read time indicator
********************************************/

if ($('.js-reading-time').length) {
	$(function () {
		var txt = $(".js-reading-content")[0].textContent,
			wordCount = txt.replace(/[^\w ]/g, "").split(/\s+/).length,
			wpm = 250,
			readingTimeInMinutes = 1;

		var readingTime = wordCount / wpm;
		var readingTimeModulo = readingTime - Math.floor(readingTime);
		if (wordCount > wpm) {
			if ((readingTimeModulo >= 0) && (readingTimeModulo < 0.8)) {
				readingTimeInMinutes = Math.floor(wordCount / wpm);
			} else {
				readingTimeInMinutes = Math.floor(wordCount / wpm) + 1;
			}
		}

		$('.js-reading-time').html(readingTimeInMinutes);
	});
}
